import React from "react";

function HorizontalIcons({ icons }) {
  return (
    <ul className="flex pt-20 pb-16 font-anton uppercase justify-center container mx-auto flex-wrap horizontal-icons-component">
      {icons.map((icon, i) => (
        <React.Fragment key={i}>
          <li className="w-auto text-center inline-flex flex-col px-10 mb-8">
            <div className="text-center">
              <img
                src={icon.image}
                className="h-20 mx-auto flex-initial"
                alt=""
              />
            </div>
            <span
              className="text-xl mt-3"
              dangerouslySetInnerHTML={{ __html: icon.text }}
            ></span>
          </li>
        </React.Fragment>
      ))}
    </ul>
  );
}

export default HorizontalIcons;
